module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "main-bg-gradient skew top-panel services-top"
  }, [_c('div', {
    staticClass: "inside-skew"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8"
  }, [_c('div', {
    attrs: {
      "id": "service-window"
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.windowBox === 1),
      expression: "windowBox === 1"
    }],
    attrs: {
      "src": "/static/images/services/window1.svg"
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.windowBox === 2),
      expression: "windowBox === 2"
    }],
    attrs: {
      "src": "/static/images/services/window2.svg"
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.windowBox === 3),
      expression: "windowBox === 3"
    }],
    attrs: {
      "src": "/static/images/services/window3.svg"
    }
  })])])])])])]), _vm._v(" "), _c('section', {
    staticClass: "skew"
  }, [_c('div', {
    staticClass: "inside-skew"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row window-boxes animated fadeIn"
  }, [_c('div', {
    staticClass: "col-lg-4"
  }, [_c('div', {
    staticClass: "window-box",
    class: {
      'active': _vm.windowBox === 1
    },
    on: {
      "click": function($event) {
        _vm.windowBox = 1
      }
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('service.mainbox1Header')))]), _vm._v(" "), _c('p', {
    staticClass: "smaller"
  }, [_vm._v("\n                                " + _vm._s(_vm.$t('service.mainbox1Text')) + "\n                            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('div', {
    staticClass: "window-box",
    class: {
      'active': _vm.windowBox === 2
    },
    on: {
      "click": function($event) {
        _vm.windowBox = 2
      }
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('service.mainbox2Header')))]), _vm._v(" "), _c('p', {
    staticClass: "smaller"
  }, [_vm._v("\n                                " + _vm._s(_vm.$t('service.mainbox2Text')) + "\n                            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('div', {
    staticClass: "window-box",
    class: {
      'active': _vm.windowBox === 3
    },
    on: {
      "click": function($event) {
        _vm.windowBox = 3
      }
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('service.mainbox3Header')))]), _vm._v(" "), _c('p', {
    staticClass: "smaller"
  }, [_vm._v("\n                                " + _vm._s(_vm.$t('service.mainbox3Text')) + "\n                            ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('h2', [_vm._v("\n                            " + _vm._s(_vm.$t('service.firstServiceHeader')) + "\n                        ")]), _vm._v(" "), _c('p', [_vm._v("\n                            " + _vm._s(_vm.$t('service.firstServiceText')) + "\n                        ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-rounded btn-primary",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('service.readmore')) + "\n                        ")])])])])])]), _vm._v(" "), _c('section', {
    staticClass: "bg-deveo-light skew bottom-panel"
  }, [_c('div', {
    staticClass: "inside-skew"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('h2', [_vm._v("\n                            " + _vm._s(_vm.$t('service.secondServiceHeader')) + "\n                        ")]), _vm._v(" "), _c('p', [_vm._v("\n                            " + _vm._s(_vm.$t('service.secondServiceText')) + "\n                        ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-rounded btn-primary",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('service.readmore')) + "\n                        ")])])])])])]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-4",
    attrs: {
      "align": "right"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://assets.railsware.com/images/services/web-services-5a281186.svg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-4",
    attrs: {
      "align": "right"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://assets.railsware.com/images/services/web-services-5a281186.svg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "bg-deveo-white"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('h3', [_vm._v("\n                        ???\n                    ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "200px"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c84da26"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/service/pages/index.vue
// module id = 302
// module chunks = 1